export enum TransactionType {
    DEBIT = "debit",
    CREDIT = "credit",
}